<template>
  <span><sup class="dollar-sign">$</sup><span>{{currencyValue}}</span></span>
</template>

<script>
export default {
  props: {
    value: Number,
    milkProduction: Number,
  },

  computed: {
    currencyValue() {
      const perCWTValue = (((this.value / (this.milkProduction / 100))).toFixed(2));
      return perCWTValue.toLocaleString();
    },
  },
};
</script>
